export default __webpack_public_path__ + "static/media/7.c29ad564.png";